import Address from './address-component';
import Document from './document-component';
import PersonType from './person-type-component'
import BasePerson from './base-person'
import CompanyData from './company-data/company-data'
import Crt from './company-data/crt'
import Cnae from './company-data/cnae'
import Chart from './Charts'
import {validateCNPJ} from './document-component/validate-cnpj'
import {validateCPF} from './document-component/validate-cpf'
import genericValidator from './utils/genericValidator'

export  {
    Address,
    Document,
    PersonType,
    BasePerson,
    CompanyData,
    Crt,
    Cnae,
    Chart,
    validateCPF,
    validateCNPJ,
    genericValidator
}


// WEBPACK FOOTER //
// ./src/components/parts/index.jsx